module.exports = __webpack_public_path__ + "static/organicbibs-e70b18cc4093686db3c3dfc0aedc066c.jpeg";